/**
 * Object containing base routes for user and admin sections.
 * @typedef {Object} BaseRoutes
 * @property {string} userBaseRoutes - The base route for the user section.
 * @property {string} adminBaseRoutes - The base route for the admin section.
 */

/**
 * Constant object holding the base routes for the user and admin sections of the application.
 * These routes can be used for navigation within their respective sections.
 * @type {BaseRoutes}
 */
export const baseRoutes = {
  userBaseRoutes: "/",
  adminBaseRoutes: "/admin",
};
